export type responseType = {
  [key: string]: {
    [key: string]: number;
  };
};

export type methodResult = {
  data: {
    [key: string]: number[];
  };
  columnTotal: number[];
  rowTotal: {
    [key: string]: number;
  };
};

/**
 * XXXXAPIから取得したResponseを、
 * 画面表示用のテーブルに合わせたオブジェクトに変換する
 * @param responseDto APIから取得したResponse
 * @param columns 画面表示上での列
 * @param rows 画面表示上での行
 */
export function getTableCells(responseDto: responseType, columns: string[], rows: string[]): methodResult {
  const rowsTotal: number[] = [];
  const columnTotal: {
    [key: string]: number;
  } = {};
  const data: {
    [key: string]: number[];
  } = {};

  rows.forEach((rowName: string) => {
    columnTotal[rowName] = 0;
    data[rowName] = [];
  });

  columns.forEach((columnName: string) => {
    const rowDataFromDto = responseDto[columnName];

    let rowCount = 0;
    rows.forEach((rowName: string) => {
      const countNum = rowDataFromDto[rowName];

      data[rowName].push(countNum);
      if (rowName !== 'customers') {
        rowCount += countNum;
      }
      columnTotal[rowName] += countNum;
    });
    rowsTotal.push(rowCount);
  });

  return {
    data: data,
    rowTotal: columnTotal,
    columnTotal: rowsTotal,
  };
}
